import RightsTile from "../../components/RightsTile";
import { connect } from "react-redux";
import {
  fetchSubrights,
  fetchLearnMores,
  setSelectedRightCategory,
  setSelectedSubright,
} from "../actions/rightsActions";

const mapDispatchToProps = (dispatch) => ({
  fetchSubrights: (rightsCategoryId) => {
    dispatch(fetchSubrights(rightsCategoryId));
  },
  fetchLearnMores: (subrightID) => {
    dispatch(fetchLearnMores(subrightID));
  },
  setSelectedRightCategory: (rightCategory) => {
    dispatch(setSelectedRightCategory(rightCategory));
  },
  setSelectedSubright: (subright) => {
    dispatch(setSelectedSubright(subright));
  },
});

export default connect(null, mapDispatchToProps)(RightsTile);
